import Vue from 'vue';

export default {
  state: {
    trancheStatuses: [],
  },
  getters: {
    trancheStatuses(state) {
      return state.trancheStatuses;
    },
    // eslint-disable-next-line
    trancheStatus: state => (id) => {
      return state.trancheStatuses.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_TRANCHE_STATUS(state, payload) {
      state.trancheStatuses = payload;
    },
  },
  actions: {
    GET_TRANCHE_STATUS(context) {
      return Vue.axios.get('filters/tranche_status').then(({ data }) => {
        context.commit('SET_TRANCHE_STATUS', data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/tranche_status.js